import axios from '../../utils/axios2'

export default {
    namespaced: true,

    state: {
        truckTypes: [],
        truckType: null
    },

    mutations: {
        setTruckTypes(state, payload) {
            state.truckTypes = payload;
        },
        setTruckType(state, payload) {
            state.truckType = payload;
        }
    },

    actions: {
        fetchTruckTypes({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: "truck-types",
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit('setTruckTypes', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response.data);
                })
            })
        },
        fetchTruckType({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `truck-types/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit('setTruckType', response.data);
                    resolve();
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            })
        },
        storeTruckType({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: "truck-types",
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            }) 
        },
        updateTruckType({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `truck-types/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            }) 
        },
        removeTruckType({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `truck-types/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            })
        }
    }
}